import { useCallback } from 'react'

import { normalizeExecuteCommandBody } from '@helpers'

import { getFormData } from '../helpers'
import { ExecuteCommandRecordArgs } from '../types'

import { useExecuteCommandMutationWithFixedKey } from './useExecuteCommandMutationWithFixedKey'

export const useUpdateObjectDataRecordWithFixedKey = (globalId: string) => {
  const fixedCacheKey = `update-object-data-record-${globalId}`

  const [executeCommand, executeCommandResult] =
    useExecuteCommandMutationWithFixedKey(fixedCacheKey)

  const triggerUpdate = useCallback(
    (args: ExecuteCommandRecordArgs) => {
      if (args.isFormData) {
        return executeCommand({
          method: args.method,
          objectCode: args.objectCode,
          commandCode: args.commandCode,
          resource: args.resource,
          params: args.params,
          body: getFormData(args.record),
        })
      }

      const sourceBody = args.body ?? args.record
      const body = normalizeExecuteCommandBody(sourceBody as Record<string, unknown>)

      return executeCommand({
        method: args.method,
        objectCode: args.objectCode,
        commandCode: args.commandCode,
        resource: args.resource,
        body,
        params: args.params,
      })
    },
    [executeCommand]
  )

  return [triggerUpdate, executeCommandResult] as const
}
